import React, { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore, userStore, formatApiError } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [error, setError] = useState("");

  useEffect(() => {
    const t = tokenStore.get();
    if (!t) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        userStore.set(res.data);
      })
      .catch(() => {
        tokenStore.clear();
        setUser(null);
      });
  }, []);

  const login = async (identifier, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { identifier, password });
      tokenStore.set(data.access_token);
      userStore.set(data.user);
      setUser(data.user);
      return data.user;
    } catch (e) {
      const msg = formatApiError(e.response?.data?.detail) || e.message;
      setError(msg);
      throw new Error(msg);
    }
  };

  const logout = () => {
    tokenStore.clear();
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, error }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
